import { useDrawer } from 'contexts/DrawerContext';

/* files */
import { NewFolder } from 'drawers/files/NewFolder';
import { RenameFile } from 'drawers/files/RenameFile';
import { FileDetails } from 'drawers/files/FileDetails';
import { ShareFile } from 'drawers/files/ShareFile';

/* shared files */
import { SharedFileDetails } from 'drawers/shared/SharedFileDetails';

/* deleted files */
import { DeletedFileDetails } from 'drawers/bin/DeletedFileDetails';

export const useFileDrawers = () => {
  const { openDrawer, setDrawerComponent } = useDrawer();

  /* files */
  const openDrawerNewFolder = () => {
    openDrawer({ component: NewFolder });
  };
  const openDrawerRenameFile = () => {
    openDrawer({ component: RenameFile });
  };
  const openDrawerFileDetails = () => {
    openDrawer({ component: FileDetails });
  };
  const setDrawerFileDetails = () => {
    setDrawerComponent({ component: FileDetails });
  };
  const openDrawerShareFile = () => {
    openDrawer({ component: ShareFile });
  };

  /* shared files */
  const setDrawerSharedFileDetails = () => {
    setDrawerComponent({ component: SharedFileDetails });
  };
  const openDrawerSharedFileDetails = () => {
    openDrawer({ component: SharedFileDetails });
  };

  /* deleted files */
  const setDrawerDeletedFileDetails = () => {
    setDrawerComponent({ component: DeletedFileDetails });
  };
  const openDrawerDeletedFileDetails = () => {
    openDrawer({ component: DeletedFileDetails });
  };

  return {
    /* files */
    openDrawerNewFolder,
    openDrawerRenameFile,
    openDrawerFileDetails,
    setDrawerFileDetails,
    openDrawerShareFile,

    /* shared files */
    setDrawerSharedFileDetails,
    openDrawerSharedFileDetails,

    /* deleted files */
    setDrawerDeletedFileDetails,
    openDrawerDeletedFileDetails,
  };
};
